<div
    class="agpr-dateRangeSelector"
>
    <div class="agpr-dateRangeSelector-header">
        <label
            [id]="id + '_label'"
            class="agpr-dateRangeSelector-headerLabel"
        >
            {{ header | localize }}
        </label>
    </div>

    <div class="agpr-dateRangeSelector-content">
        <div class="agpr-dateRangeSelector-dateRangeType">
            <agpr-dropdown
                [id]="selectedDateRangeOption?.label"
                [options]="options"
                [ariaLabel]="'dateRangeDropdownSelector' | localize"
                key="type"
                [ngModel]="selectedDateRangeOption"
                [placeholder]="inputPlaceholder"
                [inputTooltip]="selectedDateRangeOption?.label"
                (ngModelChange)="dateRangeSelected($event)"
            ></agpr-dropdown>
        </div>

        <div class="agpr-dateRangeSelector-dateRanges">
            <label
                [id]="id + '_startLabel'"
                class="agpr-dateRangeSelector-dateRangeLabel"
            >
                {{ 'Monitoring.dateQueryDialog.label.start' | localize }}
                <span class="u-srOnly">{{ 'dateFormat' | localize }}</span>
            </label>
            <div
                class="agpr-dateRangeSelector-dateRange"
                role="group"
                [attr.aria-labelledby]="id + '_startLabel'"
            >
                <div class="agpr-inputOverlay agpr-dateRangeSelector-calendar">
                    <span
                        [id]="id + '_startDateLabel'"
                        class="u-srOnly"
                    >
                        {{ 'date' | localize }}
                    </span>
                    <agpr-date-picker
                        #calendarStart
                        [id]="id + '_startInput'"
                        class="agpr-dateRangeSelector-dateRange-datePicker"
                        [minDate]="dateRange?.from"
                        [maxDate]="calendarEndValue ? calendarEndValue : (useToDate ? dateRange?.to : null)"
                        [ariaLabelledBy]="id + '_startDateLabel'"
                        [(ngModel)]="calendarStartValue"
                        (ngModelChange)="switchToCustomRange()"
                    ></agpr-date-picker>
                </div>
                <agpr-time-picker
                    [id]="id + '_startTime'"
                    [(ngModel)]="startTime"
                    [showTimeZoneSelector]="false"
                    (changeHour)="startOrEndTimeChanged()"
                    (changeMinute)="startOrEndTimeChanged()"
                    (changeMeridian)="startOrEndTimeChanged()"
                    [header]="'time' | localize"
                ></agpr-time-picker>
            </div>

            <label
                [id]="id + '_endLabel'"
                class="agpr-dateRangeSelector-dateRangeLabelWithMargin"
            >
                {{ 'Monitoring.dateQueryDialog.label.end' | localize }}
                <span class="u-srOnly">{{ 'dateFormat' | localize }}</span>
            </label>
            <div
                class="agpr-dateRangeSelector-dateRange"
                role="group"
                [attr.aria-labelledby]="id + '_endLabel'"
            >
                <div class="agpr-inputOverlay agpr-dateRangeSelector-calendar">
                    <span
                        [id]="id + '_endDateLabel'"
                        class="u-srOnly"
                    >
                        {{ 'date' | localize }}
                    </span>
                    <agpr-date-picker
                        #calendarEnd
                        [id]="id + '_endInput'"
                        class="agpr-dateRangeSelector-dateRange-datePicker"
                        [minDate]="calendarStartValue ? calendarStartValue : dateRange?.from"
                        [maxDate]="useToDate ? dateRange?.to : null"
                        [ariaLabelledBy]="id + '_endDateLabel'"
                        [(ngModel)]="calendarEndValue"
                        (ngModelChange)="switchToCustomRange()"
                    ></agpr-date-picker>
                </div>
                <agpr-time-picker
                    [id]="id + '_endTime'"
                    [(ngModel)]="endTime"
                    [showTimeZoneSelector]="false"
                    (changeHour)="startOrEndTimeChanged()"
                    (changeMinute)="startOrEndTimeChanged()"
                    (changeMeridian)="startOrEndTimeChanged()"
                    [header]="'time' | localize"
                ></agpr-time-picker>
            </div>

            <div class="agpr-dateRangeSelector-errorMessage">
                @if (dateRangeErrorMessage) {
                    <agpr-form-message>
                        {{ dateRangeErrorMessage | localize }}
                    </agpr-form-message>
                }
            </div>
        </div>
    </div>

    @if (
        !hideDateTypeSelection &&
        dateTypeOptions?.length > 0 &&
        value?.value.query.type !== dateQueryTypeEnum.ALL
    ) {
        <div class="agpr-dateRangeSelector-dateTypeSelector">
            <div>
                <agpr-dropdown
                    [id]="id + '_dateRangeSelector'"
                    class="agpr-dateRangeSelector-dateTypeSelectorDropdown"
                    label="Monitoring.dateQueryDialog.label.dateTypeSelector"
                    [options]="dateTypeOptions"
                    optionLabel="label"
                    [(ngModel)]="selectedDateTypeOption"
                    (ngModelChange)="apply()"
                ></agpr-dropdown>
            </div>
        </div>
    }
</div>
